import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo"
import { MultiDrag, Sortable } from "sortablejs"
import { getMetaContent } from "../lib/meta"

Sortable.mount(new MultiDrag())

export default class extends Controller {
  static values = { movePath: String, selectedSlugs: Array }
  static targets = ["slug", "bulkSelect"]
  static outlets = ["navbar"]

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      multiDrag: true,
      selectedClass: "table-info",
      handle: ".handle",
      onSelect: event => {
        if (!this.selectedSlugsValue.includes(event.item.dataset.slug)) {
          this.selectedSlugsValue = [...this.selectedSlugsValue, event.item.dataset.slug]
        }
        this.#updateBulkSelectState()
      },
      onDeselect: event => {
        this.selectedSlugsValue = this.selectedSlugsValue.filter(slug => slug !== event.item.dataset.slug)
        this.#updateBulkSelectState()
      },
      onStart: _event => {
        this.navbarOutlet.hide()
      },
      onEnd: event => {
        this.navbarOutlet.show()
        this.sortable.option("disabled", true)

        const items = event.items.length === 0 ? [event.item] : event.items
        const draggedIndex = event.items.length === 0 ? 0 : event.items.indexOf(event.item)

        fetch(this.movePathValue, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            hashids: items.map(item => item.dataset.slug),
            position: event.newIndex - draggedIndex,
            authenticity_token: getMetaContent("csrf-token")
          })
        })
          .then(response => response.text())
          .then(html => renderStreamMessage(html))
      }
    })

    const selectedSlugs = this.selectedSlugsValue || []
    if (this.hasSlugTarget) {
      this.slugTargets.forEach(el => {
        if (selectedSlugs.includes(el.dataset.slug)) {
          Sortable.utils.select(el)
        }
      })
    }

    this.#updateBulkSelectState()
  }

  #updateBulkSelectState() {
    const disabled = this.selectedSlugsValue.length > 0
    this.bulkSelectTargets.forEach(el => {
      el.disabled = disabled
      el.classList.toggle("disabled", disabled)
    })
  }
}
